import React from 'react';
import { useRecoilValue } from 'recoil';

import { getVehicleNames } from '@/components/modules/option/row/utils/get-vehicle-names';
import { Text } from '@/components/text';
import { getVehiclesByIdsState } from '@/state/vehicles';

export interface VehicleNameListProps {
  vehicleIds: string[];
}

const VehicleNameList = ({ vehicleIds }: VehicleNameListProps) => {
  const vehicleDetails = useRecoilValue(getVehiclesByIdsState(vehicleIds));

  return (
    <Text variant="sm" className="mb-0 overflow-hidden overflow-ellipsis whitespace-nowrap text-text-secondary">
      {getVehicleNames(vehicleDetails)}
    </Text>
  );
};

export { VehicleNameList };
